import React, { useState } from 'react';

import Collapse from '../../../common/components/dataEntry/components/Collapse';
import CollapsePanel from '../../../common/components/dataEntry/components/CollapsePanel';
import YourZipCode from './YourZipCode';
import YourInformation from './YourInformation';
import { Counties, Information, ZipCode } from '../../../types/index';

const YOUR_INFORMATION_KEY = '0';
const YOUR_ZIP_CODE = '1';

interface Step1Props {
  yourZipCodeInitialValues: ZipCode | null;
  onSubmitZipCode: (values: ZipCode) => void;
  yourInfoInitialValues: Information | null;
  onYourInformationComplete: (values: Information) => void;
  currentStep: number;
  onCurrentUpdated: (value: number) => void;
  setLowestCostPlan: (value: number) => void;
}

const Step1: React.FC<Step1Props> = ({
  yourZipCodeInitialValues,
  onSubmitZipCode,
  yourInfoInitialValues,
  onYourInformationComplete,
  currentStep,
  onCurrentUpdated,
  setLowestCostPlan,
}) => {
  const [enableNextAccordion, setEnableNextAccordion] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState(YOUR_ZIP_CODE);
  const [counties, setCounties] = useState<Counties | null>(null);

  if (currentStep !== 0) return null;

  const onCollapseChange = () => {
    setActiveAccordion(
      activeAccordion === YOUR_INFORMATION_KEY
        ? YOUR_ZIP_CODE
        : YOUR_INFORMATION_KEY
    );
  };
  const onEnableNextAccordion = (value: boolean) => {
    setEnableNextAccordion(value);
  };
  const getCounties = (value: Counties) => {
    setCounties(value);
  };
  return (
    <div>
      <Collapse
        activeKey={activeAccordion}
        accordion
        onChange={() => onCollapseChange()}
      >
        <CollapsePanel header="Your ZIP Code" key={YOUR_ZIP_CODE}>
          {
            <YourZipCode
              onSubmitZipCode={onSubmitZipCode}
              getCounties={getCounties}
              yourZipCodeInitialValues={yourZipCodeInitialValues}
              handleCollapse={onCollapseChange}
              enableNextAccordion={onEnableNextAccordion}
            />
          }
        </CollapsePanel>
        <CollapsePanel
          disabled={!enableNextAccordion}
          header="Your Information"
          key={YOUR_INFORMATION_KEY}
        >
          <YourInformation
            counties={counties}
            yourInfoInitialValues={yourInfoInitialValues}
            onYourInformationComplete={onYourInformationComplete}
            handleCollapse={onCollapseChange}
            nextAccordionEnabled={enableNextAccordion}
            updateStep={onCurrentUpdated}
            setLowestCostPlan={setLowestCostPlan}
          />
        </CollapsePanel>
      </Collapse>
    </div>
  );
};

export default Step1;
